/** 与 Keeper 端 channelDisplay / divisionChannel 同一套通道 logo 与通道名 */
const IMG = 'https://agent.fskeeper.com/img/'

const CHANNEL_LOGO = {
  lklpay: IMG + 'lakala-logo.png',
  lkl: IMG + 'lakala-logo.png',
  htkpay: IMG + 'lakala-logo.png',
  yqt: IMG + 'easypay-logo.png',
  yqtpay: IMG + 'easypay-logo.png',
  easypay: IMG + 'easypay-logo.png',
  lespay: IMG + 'leshualogo.png',
  les: IMG + 'leshualogo.png',
  leshua: IMG + 'leshualogo.png',
  jlianpay: IMG + 'jlian-logo.png',
  jlian: IMG + 'jlian-logo.png',
  shengpay: IMG + 'shengfutong-logo.png',
  sft: IMG + 'shengfutong-logo.png',
  yuduoma: IMG + 'yuduoma-logo.png',
  ydm: IMG + 'yuduoma-logo.png'
}

const CHANNEL_NAME = {
  lklpay: '拉卡拉',
  lkl: '拉卡拉',
  htkpay: '拉卡拉',
  yqt: '易生',
  yqtpay: '易生',
  easypay: '易生',
  lespay: '乐刷',
  les: '乐刷',
  leshua: '乐刷',
  jlian: '交联',
  jlianpay: '交联',
  shengpay: '盛付通',
  sft: '盛付通',
  yuduoma: '鱼哆码',
  yuanshoubao: '远收宝'
}

/** 后端通道字典未收录时的兜底占位名，不能当展示名用 */
const PLACEHOLDER_NAMES = ['支付通道', '未知通道', '通道']

export function resolveChannelIcon (ifCode) {
  const key = String(ifCode || '').trim().toLowerCase()
  return (key && CHANNEL_LOGO[key]) || ''
}

export function resolveChannelName (ifCode, fallbackName) {
  const key = String(ifCode || '').trim().toLowerCase()
  const name = String(fallbackName || '').trim()
  if (name && PLACEHOLDER_NAMES.indexOf(name) < 0) return name
  return (key && CHANNEL_NAME[key]) || name
}

/**
 * 小微多户选商户：后端通道字典没收录的通道（如盛付通）通道名会退化成「支付通道」且 logo 为空，
 * 这里按 channelCode / ifCode 补齐展示名与 logo，接口返回的正常值优先保留。
 */
export function resolveMicroChannel (item) {
  const payload = item || {}
  const code = String(
    payload.channelCode || payload.ChannelCode || payload.ifCode || payload.IfCode || ''
  ).trim().toLowerCase()
  const serverLogo = String(payload.channelLogo || payload.ChannelLogo || '').trim()
  return {
    name: resolveChannelName(code, payload.channelName || payload.ChannelName),
    logo: serverLogo || resolveChannelIcon(code)
  }
}

export function pickIfCode (payload) {
  if (!payload || typeof payload !== 'object') return ''
  return payload.ifCode || payload.IfCode || ''
}
